// src/utils/index.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function isBrowser() {
  return typeof window !== "undefined";
}

export {
  cn,
  isBrowser
};
//# sourceMappingURL=chunk-IX6RFIQL.js.map